import RouteResetController from 'donor-elf-web/lib/route-reset-controller';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';
import { setProperties, get, set } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import dateUtils from '../../../../lib/date-utils';

const validation = {
  startDate: validatePresence({ presence: true, message: "Can't be blank" }),
  goalDate: validatePresence({ presence: true, message: "Can't be blank" }),
  frequencyTimespan: validatePresence({
    presence: true,
    message: "Can't be blank",
  }),
  frequencyNumber: validatePresence({
    presence: true,
    message: "Can't be blank",
  }),
};

export default RouteResetController.extend({
  abilities: service(),

  beforeModel(transition) {
    if (this.abilities.noCoachingAbility('edit_individual')) {
      transition.abort();
    }
  },

  model() {
    let record = this.modelFor('coaching.individuals.individual').record;
    let changeset = new Changeset(
      record,
      lookupValidator(validation),
      validation,
    );

    // have to stringify & parse `staticInfo` and `sections` because they're arrays which the changeset can't handle
    let staticInfo = get(changeset, 'staticInfo') || [];
    set(changeset, 'staticInfo', JSON.parse(JSON.stringify(staticInfo)));
    let sections = get(changeset, 'sections') || [];
    set(changeset, 'sections', JSON.parse(JSON.stringify(sections)));

    if (isEmpty(get(changeset, 'startDate'))) {
      set(changeset, 'startDate', new Date());
    }
    if (isEmpty(get(changeset, 'frequencyNumber'))) {
      setProperties(changeset, {
        frequencyNumber: 1,
        frequencyTimespan: 'week',
      });
    }
    if (!isEmpty(get(changeset, 'goalDate'))) {
      set(
        changeset,
        'goalDateString',
        dateUtils.serializeToDateOnly(get(changeset, 'goalDate')),
      );
    }

    return {
      record,
      changeset,
    };
  },
});
